<template>
  <div id="hoursStatistical">
    <el-container class="container">
      <el-tabs v-model="activeTab" class="tabs" @tab-click="handleTabClick">
        <el-tab-pane :label="tabs[0].label" :name="tabs[0].name">
          <el-row class="search-pane">
            <el-col>
              <el-button size="small" type="primary" @click="exportOffice()">导出</el-button>
              <label class="label">部门名称：</label>
              <wl-tree-select v-model="unSubmitQuery.projectID" node-key="id" filterable :data="treeOrgData"
                :props="treeSelectProps" :default-expand-all="false" :default-expanded-keys="defaultExpandedKeys"
                :show-total="1" size="small" @change="handleTreeChanged"></wl-tree-select>
              <label class="label">选择姓名：</label>
              <el-input v-model="listQuery.checkedUser" placeholder="请输入名字" class="el-input" width="110px" size="small"></el-input>

              <label class="label">选择时间：</label>
              <el-date-picker v-model="listQuery.checkedDate" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                size="small" @change="timeSlot"></el-date-picker>
              <el-button size="small" style="margin-left: var(--middle-space)" type="primary" @click="handleSieve(true)">筛选</el-button>
              <el-button size="small" type="success" plain @click="handleRefresh()">
                重置
              </el-button>
            </el-col>
          </el-row>
          <div class="table-tree">
            <el-table class="table-pane" :data="hoursList" border height="100%">
              <el-table-column prop="userName" label="人员名称" width="220">
                <template #default="{ row }">
                  <el-link type="primary" @click="viewdetail(row)">
                    <span class="tabLinkSpan" :title="row.userName">{{ row.userName }}</span>
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column label="工作时长" width="220">
                <template slot-scope="scope">
                  <span>{{ scope.row.workTimeSum }}小时</span>
                </template>
              </el-table-column>
              <el-table-column label="加班时长" width="220">
                <template slot-scope="scope">
                  <span>{{ scope.row.overTimeSum }}小时</span>
                </template>
              </el-table-column>
              <el-table-column label="自动记录时长" width="220">
                <template slot-scope="scope">
                  <span>{{ scope.row.autoRecordTimeSum }}小时</span>
                </template>
              </el-table-column>
              <el-table-column prop="projectInfo" label="所属部门" show-overflow-tooltip></el-table-column>
            </el-table>
            <div class="page-handler">
              <pagination v-show="total > 0" :layout="pageLayout" :total="total" :page.sync="listQuery.page"
                :limit.sync="listQuery.limit" @pagination="fetchData()" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="tabs[3].label" :name="tabs[3].name">
          <el-row class="search-pane">
            <el-col :span="24">
              <label class="label">部门名称：</label>
              <wl-tree-select v-model="unSubmitQuery.projectID" node-key="id" filterable :data="treeOrgData"
                :props="treeSelectProps" :default-expand-all="false" :default-expanded-keys="defaultExpandedKeys"
                :show-total="1" size="small" @change="handleTreeChanged"></wl-tree-select>
              <label class="label">选择时间：</label>
              <el-date-picker v-model="unSubmitQuery.checkedDate" class="mr10" type="daterange" align="right"
                unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" size="small" @change="timeSlot" />
              <label class="label" style>包含周六日：</label>
              <el-radio-group v-model="unSubmitQuery.isWeekend" class="mr10">
                <el-radio label="0">包含</el-radio>
                <el-radio label="1">不包含</el-radio>
              </el-radio-group>
              <!-- :picker-options="pickerOptions" -->
              <el-button size="small" style="margin-left: var(--middle-space)" type="primary" @click="handleSieve(true)">筛选</el-button>
              <el-button size="small" type="success" plain @click="handleRefresh()">
                重置
              </el-button>
            </el-col>
          </el-row>
          <div class="table-tree">
            <el-table border class="table-pane" :data="unSubmitList" height="100%">
              <el-table-column prop="userName" label="姓名" />
              <el-table-column label="未提交日期" prop="dates" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <el-tag v-for="date in row.$dateList" :key="date" type="danger" style="margin:4px 8px">
                    {{ date }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page-handler">
            <pagination v-show="totalCount > 0" :layout="pageLayout" :total="totalCount" :page.sync="pageNo"
              :limit.sync="pageSize" @pagination="fetchData()" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-container>
    <Detail ref="detaipanel" :user-info="curUserInfo" :list-query="listQuery" />
  </div>
</template>

<script>
import wl from "wl-vue-select";
import "wl-vue-select/lib/wl-vue-select.css";
import Vue from "vue";
import * as echarts from 'echarts';
import Pagination from "@/CommonDP/components/Pagination"; // Secondary package based on el-pagination
import Detail from "./detail.vue";
import moment from "moment";
import request from "@/CommonDP/service/sysServer-service";
import orgFrameworkConfig from "@/CommonDP/service/org-service";
import { storage } from "@/CommonDP/utils";
Vue.use(wl);
moment.locale("zh-cn");
// 引入 ECharts
const defaultUnSubmitDates = [moment().weekday(0).format("YYYY-MM-DD"), moment().weekday(6).format("YYYY-MM-DD")];
const defaultUnSubmitQuery = {
  isWeekend: "1",
  projectID: undefined,
  pageIndex: 1,
  pageSize: 20,
  total: 0,
  checkedDate: [...defaultUnSubmitDates]
};
export default {
  name: "WorkTimeStatistical",
  components: { Pagination, Detail },
  data() {
    return {
      curUserInfo: {},
      searchName: "",
      deptList: [],
      activeTab: "first", // 默认的活动tab
      projectsList: [], // 项目列表
      usersList: [],
      hoursList: [], // 工时列表
      pendingList: [],
      unSubmitList: [], // 未提交列表
      prjWorkTimeList: [], // 部门工作时长列表
      userWorkTimeList: {}, // 人员工作时长列表
      prjUserList: [], // 项目人数
      lineChartOrder: "", // 部门工作时长折线图
      columnsChartOrder: "", // 人员工作时长柱状图
      userCountChart: "", // 部门总人数柱状图
      getSetOption: {
        // 折线图
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: []
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "30%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            rotate: 60
          }
        },
        yAxis: {
          type: "value"
        },
        series: []
      },
      getColumnsOption: {
        legend: {},
        tooltip: {},
        dataset: {},
        xAxis: { type: "category" },
        yAxis: {},
        series: [{ type: "bar" }, { type: "bar" }]
      },
      pageLayout: "total, prev, pager, next", // 分页组件
      total: 0, // 总条数
      tabs: [
        {
          // tabs列表（id定义对应为两种不同的类型，1：列表；2：图表）
          id: 1,
          label: "列表",
          name: "first"
        },
        {
          id: 2,
          label: "图表",
          name: "second"
        },
        {
          id: 3,
          label: "待审批",
          name: "third"
        },
        {
          id: 4,
          label: "未提交",
          name: "uncommitted"
        }
      ],
      pickerOptions: {
        // 日期快捷设置
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      table: {
        columns: [
          {
            text: "项目名称",
            value: "name",
            width: "400"
          },
          {
            text: "工作时长",
            value: "workTimeSum",
            width: "400"
          },
          {
            text: "工作时长2",
            value: "overTimeSum",
            width: "400"
          },
          {
            text: "项目人数",
            value: "userSum",
            width: ""
          }
        ]
      },
      listQuery: {
        // 查询相关
        page: 1, // 当前页
        limit: 10, // 每页限制条数
        status: 1, // 模式，默认列表模式
        checkedProject: "", // 已选项目
        checkedUser: "",
        checkedDate: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()], // 已选日期数组（初始化默认日期为最近一周）
        startDate: "", // 开始日期
        endDate: "", // 结束日期
        searchInput: "", // 关键字,
        stage: ""
      },
      stageList: [],
      unSubmitQuery: {
        ...defaultUnSubmitQuery,
        checkedDate: [...defaultUnSubmitDates]
      },
      treeOrgData: [],
      treeSelectProps: {
        label: "deptName",
        value: "deptId"
      },
      defaultExpandedKeys: [],
      pageSize: 20,
      pageNo: 1,
      totalCount: 0,
      dicPage: {
        pageNo: 1,
        pageSize: 999
      }
    };
  },
  computed: {
    enterpriseId() {
      return this.$store.state.enterprise.enterpriseId;
    },
    unSubmitListLimit() {
      const {
        unSubmitList,
        unSubmitQuery: { pageIndex, pageSize, total }
      } = this;
      return this.unSubmitList.slice((pageIndex - 1) * pageSize, pageSize * pageIndex);
    }
  },
  watch: {
    refresh(val) {
      this.drawLineChart();
      this.drawColumnsChart();
      this.drawUserCountChart();
    }
  },
  mounted() {},
  created() {
    this.fetchData();
    this.queryTreeOrginfo();
  },
  methods: {
    treeData(data) {
      this.frameTree = data;
    },
    // 选中节点
    currentOrgChangeHandler(val) {
      this.personTable = [];
      this.currentRow = val;
      this.page.totalCount = 0;
      this.parentDeptIdRow = val.parentDeptId;
      this.removePer = false;
      this.getOrgInfo();
      this.getPersonList();
    },
    // 部门下的人员列表
    async getPersonList(index = 1) {
      const dep = this.currentRow;
      const {
        page: { pageSize },
        searchQuery: { keyword },
        enterpriseId
      } = this;
      const params = {
        deptId: dep.deptId,
        keyword,
        pageNum: index,
        pageSize,
        enterpriseId,
        isQueryAll: 1
      };
      const { data, totalCount, pageNum } = await orgFrameworkConfig.orgUserList(params);
      this.page.pageNum = pageNum;
      this.page.totalCount = totalCount;
      this.personTable = data;
      this.personTable.map((item) => {
        for (const a of item.deptList) {
          a.rowID = this.currentRow.deptId;
        }
      });
    },
    // 组织列表详情
    async getOrgInfo() {
      const e = this.currentRow;
      const { data } = await orgFrameworkConfig.orgInfo(e.deptId);
      this.formDepartment = data;
    },
    getUsersList() {
      this.timeSlot(this.listQuery.checkedDate);
      var params = {
        userID: "",
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate
      };
      request.getPrjUsers(params).then((res) => {
        // console.log(res,"查询");
        this.usersList = res.data;
      });
    },
    // 部门
    queryTreeOrginfo() {
      return orgFrameworkConfig
        .getOrgTree(this.enterpriseId)
        .then(({ data }) => {
          this.treeOrgData = data;
          this.defaultExpandedKeys = [data[0].deptId];
        })
        .catch((e) => console.warn(e));
    },

    handleTreeChanged(val) {
      this.unSubmitQuery.projectID = val.length > 0 ? val[0].deptId : "";
    },

    // 查询方法
    fetchData(sel) {
      this.timeSlot(this.listQuery.checkedDate);
      var params = {
        // projectID:this.listQuery.checkedProject,
        name: this.listQuery.checkedUser,
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate
      };
      if (this.listQuery.status == 1) {
        // 列表模式
        params.orgIds = this.unSubmitQuery.projectID;
        params.stage = this.listQuery.stage;
        this.getHoursList(params, this.listQuery.page, this.listQuery.limit, sel); // 默认加载工时统计数据列表
      } else if (this.listQuery.status == 4) {
        if (!this.unSubmitQuery.checkedDate) {
          this.unSubmitQuery.checkedDate = [...defaultUnSubmitDates];
        }
        const {
          unSubmitQuery: {
            isWeekend,
            projectID,
            checkedDate: [startDate, endDate]
          },
          pageSize,
          pageNo
        } = this;
        const params = {
          projectID,
          startDate,
          endDate,
          isWeekend,
          pageSize,
          pageNo,
          enterpriseId: this.enterpriseId
        };
        request.queryUserNoSubmitDate(params).then((res) => {
          this.unSubmitList = res.data;
          this.totalCount = res.totalCount;
          this.unSubmitList = res.data.map((row) => {
            const { dates } = row;
            row.$dateList = dates ? dates.split(",") : [];
            return row;
          });
          // this.unSubmitQuery.total = data.length;
          // this.unSubmitList = data.map(row => {
          //   const { dates } = row;
          //   row.$dateList = !!dates ? dates.split(",") : [];
          //   return row;
          // });
        });
        // 未提交日期
      }
    },
    resetUnSubmitQuery() {
      this.unSubmitQuery = {
        ...defaultUnSubmitQuery,
        checkedDate: [...defaultUnSubmitDates]
      };
    },
    // 获取单位项目列表
    getProjectsList() {
      // console.log(request, 'request');
      request.getDepartProjectsData().then((res) => {
        this.projectsList = res.data;
      });
    },
    // 工时列表
    async getHoursList(params, pageNo, pageSize, sel) {
      console.log(sel);
      this.total = 0;
      if (sel) {
        pageNo = 1;
      }
      var res = await request.getStatisticalHoursDataNew(params, pageNo, pageSize);
      if (res.result == "0") {
        this.hoursList = res.data;
        this.total = res.totalCount;
      } else {
        this.$message.error("查询失败");
      }
    },

    async getPendingList(params, pageNo, pageSize, sel) {
      console.log(sel);
      this.total = 0;
      if (sel) {
        pageNo = 1;
      }
      var res = await request.getStatisticalHoursDataNew(params, pageNo, pageSize);
      if (res.result == "0") {
        console.log(res.data, "pendinglist");
        this.pendingList = res.data;
        this.total = res.totalCount;
      } else {
        this.$message.error("查询失败");
      }
    },
    getPrjWorkTime() {
      this.prjWorkTimeList = [];
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        // projectID:this.listQuery.checkedProject,
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate
      };
      request
        .getPrjWorkTimeData(params)
        .then((res) => {
          if (res.data.length > 0) {
            const workTimeArr = [];
            const prjList = [];
            for (var i = 0; i < res.data.length; i++) {
              workTimeArr.push(res.data[i].workTimeSum);
              prjList.push(res.data[i].projectName);
            }
            const a = new Object();
            a.type = "line";
            a.name = "部门工作时长";
            a.data = workTimeArr;
            a.itemStyle = {
              normal: {
                color: "#1790FF",
                lineStyle: {
                  color: "#1790FF"
                }
              }
            };
            this.prjWorkTimeList.push(a);
            console.log(this.prjWorkTimeList);
            this.lineChartOrder.setOption({
              dataZoom: {
                show: true,
                realtime: true,
                y: 36,
                height: 20,
                start: 20,
                end: 80
              },
              tooltip: {
                trigger: "axis"
              },
              legend: {
                data: ["部门工作时长"],
                x: "right",
                y: "top"
              },
              grid: {
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true
              },

              yAxis: {
                type: "value"
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: prjList,
                axisLabel: {
                  rotate: 40
                }
              },
              series: this.prjWorkTimeList
            });
          }
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    getUserWorkTime() {
      this.userWorkTimeList = {};
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        // projectID:this.listQuery.checkedProject,
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate
      };
      request
        .getPrjUserData(params)
        .then((res) => {
          if (res.data.length > 0) {
            this.userWorkTimeList.dimensions = ["userName", "工作时长", "工作时长2"];
            var tempArr = [];
            for (var i = 0; i < res.data.length; i++) {
              var obj = new Object();
              obj.userName = res.data[i].userName;
              obj.工作时长 = res.data[i].workTimeSum;
              obj.工作时长2 = res.data[i].overTimeSum;
              tempArr.push(obj);
            }
            this.userWorkTimeList.source = tempArr;
            console.log(this.userWorkTimeList);
            this.columnsChartOrder.setOption({
              dataZoom: {
                show: true,
                realtime: true,
                y: 36,
                height: 20,
                start: 20,
                end: 80
              },
              legend: {
                x: "right",
                y: "top"
              },
              tooltip: {},
              dataset: this.userWorkTimeList,
              xAxis: {
                type: "category",
                axisLabel: {
                  rotate: 40
                }
              },
              yAxis: {},

              series: [
                {
                  type: "bar",
                  barWidth: 15,
                  itemStyle: {
                    normal: {
                      color: "#1790FF"
                    }
                  }
                },
                {
                  type: "bar",
                  barWidth: 15,
                  itemStyle: {
                    normal: {
                      color: "#2FC15A"
                    }
                  }
                }
              ]
            });
          } else {
            this.columnsChartOrder.setOption({
              dataZoom: {
                show: true,
                realtime: true,
                y: 36,
                height: 20,
                start: 20,
                end: 80
              },
              legend: {
                x: "right",
                y: "top"
              },
              tooltip: {},
              dataset: {
                dimensions: ["userName", "工作时长", "工作时长2"],
                source: [{ username: "--" }, { 工作时长: 0 }, { 工作时长2: 0 }]
              },
              xAxis: { type: "category" },
              yAxis: {},
              series: [
                {
                  type: "bar",
                  barWidth: 15,
                  itemStyle: {
                    normal: {
                      color: "#1790FF"
                    }
                  }
                },
                {
                  type: "bar",
                  barWidth: 15,
                  itemStyle: {
                    normal: {
                      color: "#2FC15A"
                    }
                  }
                }
              ]
            });
          }
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    getPrjUser() {
      this.prjUserList = [];
      this.projectsList = [];
      this.timeSlot(this.listQuery.checkedDate);
      const params = {
        // projectID:this.listQuery.checkedProject,
        startDate: this.listQuery.startDate,
        endDate: this.listQuery.endDate
      };
      request
        .getUserWorkTimeData(params)
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.prjUserList.push(res.data[i].peopleNumber);
            this.projectsList.push(res.data[i].projectName);
          }
          this.userCountChart.setOption({
            dataZoom: {
              show: true,
              orient: "vertical",
              right: 100,
              start: 0,
              end: 30
            },
            tooltip: {},
            legend: {
              data: ["部门总人数"],
              x: "right",
              y: "top"
            },
            grid: {
              left: "20%"
            },
            xAxis: {
              type: "value"
            },
            yAxis: {
              type: "category",
              data: this.projectsList
            },
            series: [
              {
                name: "部门总人数",
                type: "bar",
                barWidth: 15,
                itemStyle: {
                  normal: {
                    color: "#1790FF"
                  }
                },
                data: this.prjUserList
              }
            ]
          });
        })
        .then(() => {
          // this.$message.success('查询成功');
        });
    },
    drawLineChart() {
      this.lineChartOrder = echarts.init(this.$refs.myChart1);
      this.getPrjWorkTime();
    },
    drawColumnsChart() {
      this.columnsChartOrder = echarts.init(this.$refs.myChart2);
      this.getUserWorkTime();
    },
    drawUserCountChart() {
      this.userCountChart = echarts.init(this.$refs.myChart3);
      this.getPrjUser();
    },
    // tabs切换
    handleTabClick(tab, event) {
      if (tab.index == 0) {
        this.listQuery.status = 1; // 列表模式
        this.unSubmitQuery.projectID = "";
      } else if (tab.index == 1) {
        this.listQuery.status = 4; // 待审批列表
        this.resetUnSubmitQuery();
      }
      this.fetchData();
    },
    // 筛选数据
    handleSieve(sel) {
      this.fetchData(sel);
    },
    // 刷新数据
    handleRefresh() {
      this.listQuery.checkedProject = "";
      this.listQuery.checkedUser = "";
      this.listQuery.checkedDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      this.listQuery.startDate = "";
      this.listQuery.endDate = "";
      this.listQuery.stage = "";
      this.resetUnSubmitQuery();
      this.fetchData();
    },
    // 日期格式化
    timeSlot(row, column) {
      if (row != null) {
        if (row instanceof Array) {
          this.listQuery.startDate = moment(this.listQuery.checkedDate[0]).format("YYYY-MM-DD 00:00:00");
          this.listQuery.endDate = moment(this.listQuery.checkedDate[1]).format("YYYY-MM-DD 23:59:59");
        }
      } else {
        this.listQuery.checkedDate = [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date()];
      }
    },

    async exportOffice() {
      this.timeSlot(this.listQuery.checkedDate);
      var token = storage.get("token");
      const { startDate, endDate } = this.listQuery;
      var downloadUrl = `${window.location.origin + this.$env.VUE_APP_API}/worktimeStatistics/export-excel?startDate=${startDate}&endDate=${endDate}`;
      console.log(downloadUrl, "downloadUrldownloadUrl");
      fetch(downloadUrl, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then((response) => response.blob())
        .then((res) => {
          const blob = new Blob([res]);
          const url = window.URL.createObjectURL(blob);
          const ele = document.createElement("a");
          ele.style.display = "none";
          ele.href = url;
          ele.download = "工时汇总统计_.xls";
          document.querySelectorAll("body")[0].appendChild(ele);
          ele.click();
          ele.remove();
        });
    },

    async viewdetail(userinfo) {
      this.timeSlot(this.listQuery.checkedDate);
      this.curUserInfo = userinfo;
      this.$refs.detaipanel.showDialog();
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#hoursStatistical {
  height: 100%;
  background: #fff;
  padding: var(--small-space) var(--big-space) var(--middle-space);

  .container {
    height: 100%;
  }

  .label {
    margin-left: var(--middle-space);
  }

  .org-tree {
    width: 200px;
    overflow: auto;
    display: inline-table;
    position: absolute;
    top: 30px;
    z-index: 99;
  }

  .placeholder {
    width: 200px;
    position: relative;
    display: inline-block;
    height: 56px;
    margin-right: 10px;
  }

  .el-input {
    width: 105px;
  }

  .tabs {
    width: 100%;

    .search-pane {
      padding: var(--middle-space) 0;
      border-bottom: 1px dashed #ebefff;
      margin-bottom: var(--middle-space);

      .mr10 {
        margin-right: 10px;
      }

      .text-right {
        text-align: right;
      }

      .input-box {
        width: 245px;
        margin-right: -8px;
      }
    }

    .table-pane {

      p {
        margin: 0;
      }

      .record-button {
        border: 1px solid #3e75da;
        background: #b2c9ec;
      }

      .cell .status-text {
        text-align: center;

        i {
          font-style: normal;
        }
      }

      .icon {
        font-size: 20px;
        vertical-align: middle;
      }
    }

    .page-handler {
      text-align: right;
      padding: 0 2.5%;
    }

    .table-tree {
      height: 1px;
      flex: 1 0 1px;

      .el-table--group::after,
      .el-table::before {
        background-color: transparent;
      }
    }

    .charts-list {
      width: 1600px;
      margin: 8px auto;

      .charts-item {
        width: 1600px;
        height: 460px;
        background: #ffffff;
        // float: left;
        margin-bottom: 80px;

        #myChart1,
        #myChart2,
        #myChart3 {
          width: 1600px;
          height: 400px;
        }

        border-bottom: #cccccc 1px dashed;
      }

      .charts-title {
        text-align: center;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-tabs__content{
  height: calc(100% - 40px - var(--middle-space));
  .el-tab-pane{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.viewdetail {
  cursor: pointer;
}

.viewdetail:hover {
  color: #66ccff;
}</style>
